<template>
  <div class="view-trail my-5 text-light">
    <header class="px-4 px-lg-5 text-center mt-sm-4">
      <div :style="headerStyle" class="py-5">
        <div class="my-4">
          <img :src="trail.photo" />
          <h2 class="text-light my-4">{{ trail.name }}</h2>
        </div>
      </div>
    </header>

    <action-dispatcher
      v-for="(category, index) in trail.categoryresource"
      :key="index"
      class="py-4"
      action="trails/getResources"
      :parameters="category.id"
    >
      <div class="px-4 px-lg-5">
        <h5>{{ category.name }}</h5>
      </div>
      <div class="position-relative">
        <div class="px-4 px-lg-5">
          <swiper :navigation="true" :breakpoints="breakpoints">
            <swiper-slide v-for="book in resources[category.id]" :key="book.id">
              <div class="m-2">
                <a
                  v-if="book.picture"
                  class="book-cover"
                  :href="book.external_link ? book.external_link : book.file"
                  target="_blank"
                >
                  <img class="img-fluid" :src="book.picture" />
                </a>
                <a
                  v-else
                  class="default-book book-cover"
                  :href="book.external_link ? book.external_link : book.file"
                  target="_blank"
                >
                  {{ book.name }}
                </a>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </action-dispatcher>

    <!-- <action-dispatcher
      class="py-4"
      action="trails/getLessons"
      :parameters="$route.params.id"
    >
      <div class="px-4 px-lg-5">
        <h5>Cadernos de ativação</h5>
      </div>
      <div class="position-relative">
        <div class="px-4 px-lg-5">
          <swiper :breakpoints="breakpoints">
            <swiper-slide v-for="lesson in lessons" :key="lesson.id">
              <lesson-slide :lesson="lesson" />
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </action-dispatcher> -->

    <action-dispatcher
      class="py-4"
      action="trails/getMasterclasses"
      :parameters="$route.params.id"
    >
      <div class="px-4 px-lg-5">
        <h5>Aulas</h5>
      </div>
      <div class="position-relative">
        <div class="px-4 px-lg-5">
          <swiper :navigation="true" :breakpoints="livesBreakpoints">
            <swiper-slide
              v-for="masterclass in masterclasses"
              :key="masterclass.id"
            >
              <lesson-slide :lesson="masterclass" />
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </action-dispatcher>

    <!-- <action-dispatcher
      class="py-4"
      action="trails/getLives"
      :parameters="$route.params.id"
    >
      <div class="px-4 px-lg-5">
        <h5>Lives</h5>
      </div>
      <div class="position-relative">
        <div class="px-4 px-lg-5">
          <swiper :navigation="true" :breakpoints="livesBreakpoints">
            <swiper-slide v-for="live in lives" :key="live.id">
              <episode-slide :resource="live" :trail="$route.params.id" />
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </action-dispatcher> -->

    <action-dispatcher
      class="py-4"
      action="trails/getAudios"
      :parameters="$route.params.id"
    >
      <div class="px-4 px-lg-5">
        <h5>Áudios</h5>
      </div>
      <div class="position-relative">
        <div class="px-4 px-lg-5">
          <swiper :navigation="true" :breakpoints="audiosBreakpoints">
            <swiper-slide v-for="audio in audios" :key="audio.id">
              <audio-slide :resource="audio" :trail="$route.params.id" />
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </action-dispatcher>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Swiper from "@/components/Swiper";
import SwiperSlide from "@/components/SwiperSlide";
import LessonSlide from "@/components/home/LessonSlide";
import AudioSlide from "@/components/trail/AudioSlide";
// import EpisodeSlide from "@/components/trail/EpisodeSlide";
import { breakpoints } from "@/functions/helpers.js";

export default {
  components: {
    Swiper,
    SwiperSlide,
    LessonSlide,
    AudioSlide
    // EpisodeSlide
  },
  data() {
    return {
      breakpoints,
      livesBreakpoints: {
        768: {
          slidesPerView: 2
        },
        992: {
          slidesPerView: 3
        },
        1200: {
          slidesPerView: 4
        },
        1600: {
          slidesPerView: 5
        }
      },
      audiosBreakpoints: {
        992: {
          slidesPerView: 2
        },
        1200: {
          slidesPerView: 3
        },
        1600: {
          slidesPerView: 4
        }
      }
    };
  },
  computed: {
    ...mapState("courses", ["categories"]),
    ...mapState("trails", [
      "books",
      "masterclasses",
      "lives",
      "audios",
      "resources"
    ]),
    trail() {
      return this.categories.find(
        category => category.id === parseInt(this.$route.params.id)
      );
    },
    headerStyle() {
      if (!this.trail) return null;
      return {
        "background-image": `
          linear-gradient(to top, #131212, #131212DD 30%),
          url('${this.trail.background}')`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.view-trail {
  header {
    @media screen and (max-width: 575px) {
      padding: 0;
    }

    > div {
      background-size: cover;
      background-position-x: center;
      background-position-y: center;
    }
  }

  h5 {
    margin-bottom: 16px;
    font-size: 18px;
  }

  .default-book {
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.1);
    background-image: radial-gradient(ellipse at top, #fb263e33, transparent),
      radial-gradient(ellipse at bottom, #263efb33, transparent);
    color: rgba(255, 255, 255, 0.8);
    overflow: hidden;
    font-size: 10px;
    font-weight: bold;
    word-break: break-all;
    padding: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .book-cover {
    position: relative;
    display: block;
  }
}
</style>
